import R from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CardoGroup from '@cotyorg/ccx-organism-cardo-group/components/CardoGroup';
import { CardoList } from '@cotyorg/ccx-organism-cardo-list';
import Breadcrumbs from '@cotyorg/ccx-molecules/Breadcrumbs';
import { HeroFullAsymmetric } from '@cotyorg/ccx-organism-hero';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import StandardLayout from '../../templates/StandardLayout';
import PageDescription from '../../organisms/PageDescription';
import {
  cardSection1BreakpointConfig,
  cardSection2BreakpointConfig,
} from './cardo.config';

export const AllHowToComponent = ({
  sectionHeadings,
  breadcrumb,
  cardsSection1,
  cardsSection2,
  cardsSection3,
}) => (
  <StandardLayout>
    <div className="all-how-to">
      <div className="main-hero-section">
        <Breadcrumbs items={breadcrumb} />
        <div className="main-hero-heading">
          <PageDescription
            heading={R.path(['pageHeaderSection', 'heading'], sectionHeadings)}
            text={R.path(
              ['pageHeaderSection', 'introduction'],
              sectionHeadings
            )}
          />
        </div>

        <div className="grid-container">
          <div className="grid-x">
            <div className="cell xsmall-16">
              <div className="all-trends__hero-main">
                <HeroFullAsymmetric
                  alignment="bottom"
                  isUnderlined={false}
                  heroStoreDataKey="hero1"
                  headingHasLink
                  imageHasLink
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid-container">
        <div className="grid-x">
          <div className="cell xsmall-16 medium-14 medium-offset-1">
            <OptionalSection
              renderCondition={!R.isEmpty(cardsSection1)}
              section={() => (
                <div className="grid-x grid-margin-x all-how-to__card">
                  <CardoGroup
                    data="cardsSection1"
                    baseBreakpointConfig={cardSection1BreakpointConfig}
                    isTitleUnderlined={false}
                    headingLevel={4}
                    fixedHeight
                    zoomOnHover
                  />
                </div>
              )}
            />
            <OptionalSection
              renderCondition={!R.isEmpty(cardsSection2)}
              section={() => (
                <div className="grid-x grid-margin-x all-how-to__card">
                  <CardoGroup
                    data="cardsSection2"
                    baseBreakpointConfig={cardSection2BreakpointConfig}
                    isTitleUnderlined={false}
                    headingLevel={4}
                    fixedHeight
                    zoomOnHover
                  />
                </div>
              )}
            />
            <OptionalSection
              renderCondition={!R.isEmpty(cardsSection3)}
              section={() => (
                <div className="grid-x grid-margin-x">
                  <CardoList
                    id="cards-section-3"
                    data={cardsSection3}
                    extraClass="all-trends"
                    contentTheme="alpha"
                    breakpointConfig={cardSection1BreakpointConfig}
                    isTitleUnderlined={false}
                    isSmallTitle
                    headingLevel={4}
                    initialNumberToShow={0}
                    fixedHeight={false}
                    showMoreIconSrc="/ccx-files/assets/plus-within-circle.svg"
                  />
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

AllHowToComponent.propTypes = {
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
  breadcrumb: PropTypes.arrayOf(PropTypes.object),
  cardsSection1: PropTypes.arrayOf(PropTypes.object),
  cardsSection2: PropTypes.arrayOf(PropTypes.object),
  cardsSection3: PropTypes.arrayOf(PropTypes.object),
};

export default connect(({ content }) => ({
  breadcrumb: R.prop('breadcrumb', content),
  sectionHeadings: R.prop('sectionHeadings', content),
  cardsSection1: R.path(['cardoGroup', 'cardsSection1'], content),
  cardsSection2: R.path(['cardoGroup', 'cardsSection2'], content),
  cardsSection3: R.path(['cardoGroup', 'cardsSection3'], content),
}))(AllHowToComponent);
